/* eslint-disable react/no-unescaped-entities */
import React, { useState } from 'react';
import { HiArrowNarrowRight } from 'react-icons/hi';
import { Link } from 'react-scroll'


const Home = () => {
    const [nav, setNav] = useState(false);
    // eslint-disable-next-line no-unused-vars
    const handleClick = () => setNav(!nav);
    return (
        <div name='home' className='w-full h-screen bg-[#0a192f]'>
            {/* Container */}
            <div className='max-w-[1000px] mx-auto px-8 flex flex-col justify-center h-full'>
                <p className='text-blue-600'>Hi! I am</p>
                <h1 className='text-4xl sm:text-7xl font-bold text-[#ccd6f6]'>
                    Steven Kwizera
                </h1>
                <h2 className='text-4xl sm:text-7xl font-bold text-[#8892b0]'>
                    I'm a Web Developer.
                </h2>
                <p className='text-[#8892b0] py-4 max-w-[700px]'>
                    Passionate software development professional with experience in Software development
                    applications. Consistent in delivering clean, error-free, reliable code to meet current or
                    expected needs. Well-versed in software trends and confident in multiple languages, frameworks
                    and programming tools.
                </p>
                <div>
                    <button className='text-white group border-2 px-6 py-3 my-2 flex items-center hover:bg-pink-600 hover:border-pink-600'>
                        <Link onClick={handleClick} to='work' smooth={true} duration={500}>
                            View Work
                        </Link>

                        <span className='group-hover:rotate-90 duration-300'>
                            <HiArrowNarrowRight className='ml-3 ' />
                        </span>
                    </button>
                </div>
            </div>
        </div>
    );
};

export default Home;